import { render, staticRenderFns } from "./CmgNutritionCalculatorRecents.vue?vue&type=template&id=21993c5d&scoped=true&lang=pug&"
import script from "./cmg-nutrition-calculator-recents.ts?vue&type=script&lang=ts&"
export * from "./cmg-nutrition-calculator-recents.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNutritionCalculatorRecents.vue?vue&type=style&index=0&id=21993c5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21993c5d",
  null
  
)

export default component.exports